// extracted by mini-css-extract-plugin
module.exports = {"Background":"Loader_Background__QThmQ","Loader":"Loader_Loader__ANdA0","lds-facebook":"Loader_lds-facebook__2XTRT"};